// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Attachment picker used by the chat composers. Root: .file-upload */
.file-upload {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  padding: 10px 20px;
}

.file-upload .ant-upload-wrapper {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
}

.file-upload .file-upload__trigger--attached {
  color: var(--ds-brand-strong);
  background: var(--ds-brand-tint);
}

.file-upload .filRender:empty {
  display: none;
}

.file-upload .filRender img {
  width: 43px;
  height: 43px;
}
`, "",{"version":3,"sources":["webpack://./src/commons/Chats/FileUpload/FileUpload.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["/* Attachment picker used by the chat composers. Root: .file-upload */\n.file-upload {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  padding: 10px 20px;\n}\n\n.file-upload .ant-upload-wrapper {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n}\n\n.file-upload .file-upload__trigger--attached {\n  color: var(--ds-brand-strong);\n  background: var(--ds-brand-tint);\n}\n\n.file-upload .filRender:empty {\n  display: none;\n}\n\n.file-upload .filRender img {\n  width: 43px;\n  height: 43px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
